import type { ComponentChildren } from 'preact';
import { cn } from '@/lib/cn';

export interface RightRailProps {
  children: ComponentChildren;
  className?: string;
  sticky?: boolean;
}

export function RightRail({ children, className, sticky = true }: RightRailProps) {
  return (
    <aside
      className={cn(
        'border-border-subtle bg-surface min-w-0 rounded-lg border p-6',
        sticky && 'xl:sticky xl:top-6 xl:self-start',
        className,
      )}
    >
      {children}
    </aside>
  );
}
